import { SvgIcon } from '@mui/material';
import { motion } from 'motion/react';
import { forwardRef } from 'react';

import type { AnimatedIconProps, AnimeatableIconRef } from './types';
import { pathVariants } from './types';
import { useAnimatedIcon } from './useAnimatedIcon';

const ChartColumnIncreasingIcon = forwardRef<
  AnimeatableIconRef,
  AnimatedIconProps
>(({ size = 28, strokeWidth = 2, titleAccess, color }, ref) => {
  const controls = useAnimatedIcon(ref);

  return (
    <SvgIcon
      titleAccess={titleAccess}
      color={color}
      sx={{ width: size, height: size }}
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <motion.path
          variants={pathVariants}
          initial="visible"
          animate={controls}
          custom={1}
          d="M13 17V9"
        />
        <motion.path
          variants={pathVariants}
          initial="visible"
          animate={controls}
          custom={2}
          d="M18 17V5"
        />
        <path d="M3 3v16a2 2 0 0 0 2 2h16" />
        <motion.path
          variants={pathVariants}
          initial="visible"
          animate={controls}
          custom={0}
          d="M8 17v-3"
        />
      </svg>
    </SvgIcon>
  );
});

ChartColumnIncreasingIcon.displayName = 'ChartColumnIncreasingIcon';

export { ChartColumnIncreasingIcon };
